module.exports = {"oauth":{"ja":"アプリ連携確認","en":"App Sync Status"},"login":{"ja":"団体専用ログイン","en":"Login"},"company":{"ja":"団体専用ページへ","en":"Group page"},"logout":{"ja":"ログアウト","en":"Logout"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/constants/header.json
// module id = vyhV
// module chunks = 1